(function(){
  function initRooms(root){
    if (!root || root.dataset.roomsReady === 'true') return;
    var track=root.querySelector('[data-room-track]');
    if(!track) return;
    root.dataset.roomsReady='true';
    var buttons=root.querySelectorAll('[data-room-scroll]');
    function update(){
      var max=Math.max(0,track.scrollWidth-track.clientWidth);
      buttons.forEach(function(btn){
        btn.disabled=btn.getAttribute('data-room-scroll')==='prev' ? track.scrollLeft<3 : track.scrollLeft>=max-3;
      });
    }
    buttons.forEach(function(button){
      button.addEventListener('click',function(){
        var item=track.querySelector('.tekled-room-v2__item');
        var gap=parseFloat(getComputedStyle(track).gap)||13;
        var jump=item?item.getBoundingClientRect().width+gap:260;
        var direction=button.getAttribute('data-room-scroll')==='prev'?-1:1;
        track.scrollBy({left:direction*jump*2,behavior:'smooth'});
      });
    });
    track.addEventListener('scroll',update,{passive:true});
    window.addEventListener('resize',update);
    update();
  }
  function initAll(){ document.querySelectorAll('[data-room-section]').forEach(initRooms); }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initAll);}else{initAll();}
  document.addEventListener('shopify:section:load',initAll);
})();
